import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ProductDtoConverterServiceService } from 'src/app/services/product-dto-converter-service/product-dto-converter-service.service';
import { UtilService } from 'src/app/services/util-service/utilService';
import { UserService } from 'src/app/services/user-service/userservice';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { MinLengthErrorStateMatcher } from "src/environments/validators";
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ProductDetailDisplayFullComponent } from 'src/app/components/marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { NgModel } from '@angular/forms';


@Component({
    selector: 'app-create-product-variant-screen',
    templateUrl: './create-product-variant-screen.component.html',
    styleUrls: ['./create-product-variant-screen.component.css'],
    standalone: false
})
export class CreateProductVariantScreenComponent implements OnInit, OnDestroy {
    public variant: ProductVariantInterface;
    public version: VariantVersionInterface;
    public product?: ProductInterface;
    private isFormValid: boolean = false;
    private isDescriptionValid: boolean = true;
    variantNameErrorStateMatcher = new MinLengthErrorStateMatcher(160);
    commonFeatures: ProductCommonFeatureInterface[] = [];   
    formTitle: string = "Produktvariante anlegen";

    @ViewChild('variantNameCtrl') variantNameCtrl: NgModel;

    constructor(
        private commonFeatureService: CommonFeatureService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        public productService: ProductService,
        private productVariantService: ProductVariantService,
        private productDtoConverterService: ProductDtoConverterServiceService,
        private router: Router,
        private dialogService: DialogService,
        private utilService: UtilService,
        public attributeValidationService: AttributeValidationServiceService,
        private userService: UserService,
        private organisationService: OrganisationService,
        private titleService: Title
    ) {
        //Reroutes to marketplace if the user is not a member of the organisation
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    ngOnInit(): void {
        window.addEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(true);
        this.version = {};

        this.variant = {
            name: '',
            variantVersions: [this.version],
            description: ''
        };
        this.titleService.setTitle(
            this.productService.activeItem.name +
            ': Variante anlegen - BIMSWARM'
        );
    }

    ngOnDestroy(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(false);
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    private unloadHandler = (event: BeforeUnloadEvent) => {
        if (this.hasPendingChanges()) {
            event.preventDefault();
            event.returnValue = ''; // required for Chrome
        }
    };

    hasPendingChanges(): boolean {
        return this.utilService.isDirty();
    }

    cancelCreateVariant(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(false);
        this.router.navigate([
            this.productDtoConverterService.getRedirectUrl() +
            this.productService.activeItem.id
        ]);
    }

    createVariant(): void {
        if (
            !UtilService.areStringsValid(
                this.variant.name,
                this.variant.description
            )
        ) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Der Name oder die Beschreibung sind zu lang.'
            );
            return;
        }

        if (!UtilService.areStringsValid(this.version.name, null)) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte stellen sie sicher, dass der Name der Version nicht zu lang ist.'
            );
            return;
        }

        if (this.variant.description == null) {
            this.variant.description = '';
        }
        if (this.version.description == null) {
            this.version.description = '';
        }

        if (
            this.utilService.isStringNullOrEmpty(this.variant.name) ||
            this.utilService.isStringNullOrEmpty(this.version.name)
        ) {
            this.dialogService.openDialog(
                'Variante erstellen',
                'Bitte geben Sie einen Varianten- und Versionsnamen an!'
            );
            return;
        }

        this.applyDescriptionOrderToVersionName();
        this.version.attributeValidationValues =
            this.attributeValidationService.getAttributeValidationValues();

        this.productVariantService.postItem(this.variant).then(
            (x) => {
                let url =
                    '/organisations/' +
                    this.productService.activeItem.company +
                    '/products/' +
                    this.productService.activeItem.id;
                this.router.navigateByUrl(url);
                this.dialogService.openDialog(
                    'Variante erstellt',
                    'Die neue Variante ' +
                    x.name +
                    ' wurde erfolgreich erstellt.'
                );
                window.removeEventListener('beforeunload', this.unloadHandler);
                this.utilService.setDirty(false);
            },
            (e) => { }
        );
    }

    public onValidityChanged(valid: boolean): void {
        this.isFormValid = valid;
    }

    public onDescriptionValidityChange(descriptionValid: boolean): void {
        this.isDescriptionValid = descriptionValid;
    }

    isVariantVersionStepComplete(): boolean {
        return this.variantNameCtrl?.valid === true &&
            this.variantNameCtrl.value?.length <= 160 &&
            this.isDescriptionValid &&
            !!this.isFormValid;
    }

    async openProductDetailsPageDialog(
        title: string
    ): Promise<Observable<any>> {
        this.product = this.productService.activeProduct;
        this.product.productVariants.push(this.variant);
        this.commonFeatureService
            .getFeaturesForProduct(this.productService.activeProduct.id)
            .subscribe((success) => {
                this.commonFeatures = success;
                this.cdr.detectChanges();
            });
        const reference = this.dialog.open(ProductDetailDisplayFullComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                title: 'Produktübersicht',
                product: this.product,
                preview: true,
                commonFeatures: this.commonFeatures
            }
        });
        return reference.afterClosed();
    }

    private applyDescriptionOrderToVersionName(): void {
        const orderParts: string[] = [];

        this.version.ptgVersions.forEach(v => {
            const match = v.description.match(/<<>>(\d+),(\d+)$/);
            if (match) {
                const id = match[1];
                const order = match[2];
                orderParts.push(`${id},${order}`);
                v.description = '';
            }
        });

        if (orderParts.length > 0) {
            this.version.name = this.version.name.replace(/\s*<<>>[\d, -]+$/, '');
            this.version.name = `${this.version.name}<<>>${orderParts.join('-')}`;
        }
    }
}
